module.exports = __webpack_public_path__ + "img/GH-kyujin-top-osusume004.6732bff2.webp";